import { render, staticRenderFns } from "./PostOpHoldRecords.vue?vue&type=template&id=f11d09ca&"
import script from "./PostOpHoldRecords.vue?vue&type=script&lang=js&"
export * from "./PostOpHoldRecords.vue?vue&type=script&lang=js&"
import style0 from "./PostOpHoldRecords.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports